import React from "react";
import ClientDocumentsTableHeader from "./components/ClientDocumentsTableHeader";
import ClientDocumentsTableRow from "./components/ClientDocumentsTableRow";
import { VirtualTable } from "../../components/tables";
import { useClientDocuments } from "../../hooks/ClientDocumentsContext";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";

const ClientDocumentsTable = () => {
    const {
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isNewRecords,
        isRowLoaded,
        loadMore,
        newRecordsSinceCache,
        totalCount
    } = useClientDocuments()!;

    const isNewRecordsDisplayed = isNewRecords && !isLoading && !isNextPageLoading;
    return (
        <VirtualTable 
            enableScrollTracking={false}
            row={ClientDocumentsTableRow}
            header={(
                <thead>
                    <tr>
                        <ClientDocumentsTableHeader property="documentType" className={"text-center"}>Type</ClientDocumentsTableHeader>
                        <ClientDocumentsTableHeader property="fileName">File Name</ClientDocumentsTableHeader>
                        <ClientDocumentsTableHeader property="documentDescription">Description</ClientDocumentsTableHeader>
                        <ClientDocumentsTableHeader property="projectDescription">Project</ClientDocumentsTableHeader>
                        <ClientDocumentsTableHeader property="clientReadable" className="sticky-header text-center">Readable</ClientDocumentsTableHeader>
                        <ClientDocumentsTableHeader property="dateUploaded" className="text-end">Date Uploaded</ClientDocumentsTableHeader>
                        <th className="sticky-header">&nbsp;</th>
                    </tr>
                </thead>
            )}
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={isNewRecordsDisplayed}
                    newRecordsSinceCache={newRecordsSinceCache}
                    reload={refreshTable}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={51}
            itemCount={totalCount}
            itemData={data}
        />
    );
};

export default ClientDocumentsTable;